import addParam from './addParam'
import serializeParam from './serializeParam'
import cookies from './cookies'
import getUserAgent from './getUserAgent'
import domSize from './domSize'
import session_skey from './session/skey'
const ua = getUserAgent();

var _shadow = null;
export default {
  /**
   * 登录
   * @param {Function} onSuccess
   * @param {Function} onCancel
   */
  show(args) {
    var loginUrl = location.protocol + '//ui.ptlogin2.qq.com/cgi-bin/login?', sUrl = location.protocol + '//pay.qq.com/h5/h5_login_jump.shtml', params = {
      style: 38,
      appid: 11000101,
      s_url: encodeURIComponent(addParam({
        r: Math.random()
      }, sUrl)),
      low_login: 0,
      pt_no_onekey: 1,
      u: '',
      target: 'self'
    };
    loginUrl += serializeParam(params);

    var iframe = this.iframe = document.createElement('iframe');
    iframe.frameBorder = 0;
    iframe.style.display = 'none';
    iframe.src = loginUrl;
    document.body.appendChild(iframe);

    window.addEventListener('message', this._message.bind(this))

    _shadow = new Shadow();

    this.contentWindow = iframe.contentWindow;

    this.onSuccess = args.onSuccess;
    this.onCancel = args.onCancel;
  },

  _message(e) {
    if (e.source === this.contentWindow) {
      var res;
      try {
        res = JSON.parse(e.data);
      } catch (e) { }
      if (res.action === 'resize') {
        this.resize(res.width, res.height);
      } else if (res.action === 'succeed') {
        var _uin = cookies.get('uin').substr(1) * 1;
        var _skey = cookies.get('skey');
        if (!_uin || !_skey) {
          if (this.onCancel) {
            this.onCancel();
          }
          setTimeout(() => {
            alert('登录失败，请检查浏览器设置！')
          }, 0);
        } else {
          var session = new session_skey({
            uin: _uin,
            skey: _skey
          });
          if (this.onSuccess) {
            this.onSuccess(session);
          }
        }

        this.hide();
      } else if (res.action === 'close') {
        if (this.onCancel) {
          this.onCancel();
        }
        this.hide();
      }
    }
  },

  resize(width, height) {
    width = Math.max(280, width)
    height = Math.max(222, height)
    if (this.iframe) {
      var left = domSize.getScrollLeft() + domSize.getClientWidth() / 2 - width / 2;
      var top = Math.max(domSize.getScrollTop() + domSize.getClientHeight() / 2 - height / 2, domSize.getScrollTop());
      if (ua.android < 4) {
        this.iframe.style.cssText = 'left:' + left + 'px; top:' + top + 'px; position:absolute; z-index:10000;width:' + width + 'px;height:' + height + 'px';
      } else {
        this.iframe.style.cssText = 'position:absolute; top: ' + top + 'px;left: 0;right: 0;margin:0 auto; z-index:10000;width:' + width + 'px;height:' + height + 'px';
      }
    }
  },

  hide() {
    if (this.iframe) {
      if (_shadow) {
        _shadow.close();
        _shadow = null;
      }
      window.removeEventListener('message', this._message.bind(this));
      this.onSuccess = null;
      this.onCancel = null;
      this.contentWindow = null;
      document.body.removeChild(this.iframe);
      this.iframe = null;
    }
  },

  // 跳页面登录，带一键登录
  jumpToLoginPage(opt) {
    let loginUrl = '//ui.ptlogin2.qq.com/cgi-bin/login?';
    let params = {
      style: 9,
      appid: 11000101,
      s_url: encodeURIComponent(opt.url || 'https://pay.qq.com/h5/index.shtml'),
      low_login: 0,
      // pt_no_onekey : 1,
      hln_css: encodeURIComponent(location.protocol + '//imgcache.qq.com/bossweb/pay/web/images/pay_web/pay-logo.png')
    };
    loginUrl += serializeParam(params);

    location.href = loginUrl
  }
};

class Shadow {
  constructor() {
    this.container = document.createElement('div');
    var cssText = {
      position: 'fixed',
      top: '0',
      left: '0',
      width: '100%',
      height: '100%',
      'z-index': '999',
      background: '#000',
      opacity: '0.8'
    }
    cssText = Object.keys(cssText).map(key => key + ':' + cssText[key]).join(";")

    this.container.style.cssText = cssText;
    document.body.appendChild(this.container);
  }
  close() {
    document.body.removeChild(this.container);
  }
}
